import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '@app/env';
import {
  RatingTag,
  RatingSubmissionRequest,
  RatingSubmissionResponse,
  EvaluableTeacher,
  TeacherRatingRequest,
  RatingMapper,
} from '@app/mappers/rating.mapper';

@Injectable({
  providedIn: 'root',
})
export class RatingService {
  private apiUrl = environment.cdrBase;

  constructor(private http: HttpClient) {}

  getRatingTags(): Observable<RatingTag[]> {
    return this.http.get(`${this.apiUrl}/v3/ratings/tags`).pipe(map((response) => RatingMapper.toTags(response)));
  }

  getEvaluableTeachers(): Observable<EvaluableTeacher[]> {
    return this.http
      .get(`${this.apiUrl}/v3/evaluable_teachers`)
      .pipe(map((response) => RatingMapper.toEvaluableTeachers(response)));
  }

  submitTeacherRating(request: TeacherRatingRequest): Observable<unknown> {
    return this.http.post(`${this.apiUrl}/v3/teacher_ratings`, RatingMapper.toTeacherRatingPayload(request));
  }

  submitRating(request: RatingSubmissionRequest): Observable<RatingSubmissionResponse> {
    return this.http
      .post(`${this.apiUrl}/v3/ratings`, RatingMapper.toPayload(request))
      .pipe(map((response) => RatingMapper.toResponse(response)));
  }
}
